import {
	maxFontSize,
	maxTextLength,
	minFontSize,
	PI2,
	textMargin,
} from './constants';
import { fontFamily } from './styles';

export const trimNameForLabel = (name) => {
	if (name.length > maxTextLength) {
		name = `${name.substr(0, maxTextLength - '...'.length)}...`;
	}
	return name;
};

const step = 0.25;
const textFromSegmentMargin = 2;

export const calculateOptimalFontSizeForLabel = (name, segmentsLength, radius, canvasContext) => {
	const trimmedName = trimNameForLabel(name);
	canvasContext.save();
	for (let size = minFontSize; size < maxFontSize; size += step) {
		canvasContext.font = `bold ${size}vmin ${fontFamily}`;
		const textMeas = canvasContext.measureText(trimmedName);
		const { fontBoundingBoxAscent, fontBoundingBoxDescent, width } = textMeas;
		const height = fontBoundingBoxAscent + fontBoundingBoxDescent;

		if (width < (radius - (textMargin * 2))) {
			const x = radius / 2  - width / 2 + textMargin;

			const segmentHeight = getHightOfSegmentInWheel(segmentsLength, x);

			if (height > segmentHeight - (textFromSegmentMargin * 2)) {
				canvasContext.restore();

				return Math.max(minFontSize, size - step);
			}
		} else {
			canvasContext.restore();

			return Math.max(minFontSize, size - step);
		}
	}
	canvasContext.restore();
	return maxFontSize;
};

const getHightOfSegmentInWheel = (segmentsLength, pointOnRadius) => {
	if (segmentsLength === 1) {
		return pointOnRadius * 2;
	}
	const angle = PI2 / (segmentsLength * 2);
	const height = pointOnRadius * Math.tan(angle);
	return height * 2;
};
